export default __webpack_public_path__ + "static/13728-01-82eae01a6d29f8a052ee28f6721296a7.webp";